/**
 * @file 获取省市区
 * @author 小白
 */

import axios from "axios";
import useStore from "@/store";

/**
 * @description 获取省市区数据
 */
export const requestArea = async () => {
  const { data } = await axios({
    method: "get",
    url: "https://beegoedujs.oss-cn-shenzhen.aliyuncs.com/area/1.0/province.city.district.json",
  });
  return data;
};

/**
 * @description 获取省市区+详细地址返回的文字
 * @param String province 省代码
 * @param String city 市代码
 * @param String district 区代码
 * @param String address 详细地址(可传可不传)
 */
// 现阶段 (默认传参现在测试阶段，后续需要删除)
export const getAreaText = async (
  province = "",
  city = "",
  district = "",
  address = ""
) => {
  let areaText = "";
  if (!province || !city || !district) {
    return console.error("getAreaText函数需要传参省市区数据");
  }
  const area = useStore.getters["area"];
  area?.forEach((provinceItem) => {
    if (province == provinceItem.code) {
      areaText = provinceItem.name;
      provinceItem.children.forEach((cityItem) => {
        if (city == cityItem.code) {
          areaText += cityItem.name;
          cityItem.children.forEach((districtItem) => {
            if (district == districtItem.code) {
              areaText += districtItem.name + address;
            }
          });
        }
      });
    }
  });
  return areaText;
};
